import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromRouterHistoryReducer from '../reducers/router-history.reducer';

export const selectRouterHistory = createFeatureSelector<fromRouterHistoryReducer.RouterHistory>(
  'routerHistory',
);

export const getPrevUrl = createSelector(
  selectRouterHistory,
  fromRouterHistoryReducer.selectPrevUrl,
);
